import { CascadiaStackProps } from "@certn/cascadia/foundations/grid-layout/types";
import { cssToken } from "@certn/cascadia/utils";
import { css, cx } from "@emotion/css";
import { LegacyRef } from "react";

import { useLayout } from "./Layout";
import { mq } from "../../components/utils";
import { CascadiaColor } from "packages/cascadia-tokens";

interface Props extends CascadiaStackProps {
  elementRef?: LegacyRef<HTMLDivElement>;
  background?: CascadiaColor;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function Stack(props: Props) {
  const { layoutValues } = useLayout();

  const { orientation = "vertical", gap, children, background } = props;

  return (
    <div
      ref={props.elementRef}
      className={cx(
        background && css({ background: cssToken(background) }),
        styles.stack,
        props.className,
        css(
          mq({
            rowGap: layoutValues.gapVertical.map(cssToken),
            columnGap: layoutValues.gapHorizontal.map(cssToken),
          })
        )
      )}
      style={{
        rowGap: orientation === "vertical" ? cssToken(gap) : undefined,
        alignItems: props.align,
        justifyContent: props.justify,
        columnGap: orientation === "horizontal" ? cssToken(gap) : undefined,
        backgroundColor: background ? cssToken(background) : undefined,
        width: props.width,
        flexShrink: props.flexShrink,
      }}
      data-orientation={orientation}
      data-testid={props.testID}
    >
      {children}
    </div>
  );
}

const styles = {
  stack: css({
    display: "flex",
    "&[data-orientation=vertical]": {
      flexDirection: "column",
    },
    "&[data-orientation=horizontal]": {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
    },
  }),
};
